export const getInitialState = () => ({
  from: null,
  to: null,
  groupBy: "",
});
